import { createI18n } from 'vue-i18n'
import { messages } from './messages'

const resolveInitialLocale = () => {
  const stored = (localStorage.getItem('Promba_User_Language') || '').toLowerCase()
  if (stored === 'ar' || stored === 'en') {
    return stored
  }

  const browser = (navigator.language || 'en').toLowerCase()
  return browser.startsWith('ar') ? 'ar' : 'en'
}

const i18n = createI18n({
  legacy: false,
  locale: resolveInitialLocale(),
  fallbackLocale: 'en',
  messages
})

export default i18n
